// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const MyTasksPageLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-mytaskspage" */ "./MyTasksPage")).then((bundle)=>{
        return {
            default: bundle.MyTasksPage
        };
    });
export const LazyMyTasksPage = /*#__PURE__*/ lazy(MyTasksPageLazyLoader);
